import {IAntiTheft} from "@/modules/CarList/interfaces/anti-theft.interface";
import {AntiTheftActions} from "@/modules/CarList/mixins/anti-theft-actions.mixin";
import {bus} from "@/plugins/bus";

export class AntiTheftClass {
  cars: IAntiTheft.IStatusCars[] = [];
  securityActive = false;

  async init(component) {
    if (!this.cars.length) {
      await this.getAntiTheftInfo(component);
    }
  }

  async getAntiTheftInfo(component) {
    let searchedCars: IAntiTheft.IStatusCars[] = await AntiTheftActions.getCarsStatuses(component);
    this.cars = searchedCars || [];

    if (this.cars.length === 1) {
      this.securityActive = this.cars[0].theftFlag;
    }

    bus.$emit(IAntiTheft.BusEvents.GetCars);
  }

  updateSecurity(value) {
    this.securityActive = value;

    bus.$emit(IAntiTheft.BusEvents.UpdateSecurity);
  }
}

export const antiTheftCars = new AntiTheftClass();
